<template>
  <div class="item-input-container" @paste.native:="copyItem(null)">
    <label>貨品</label>
    <div class="items-container">
      <v-list style="background: transparent;" two-line>
        <div v-if="value.length > 0">
          <template v-for="(item, index) in value">
            <v-list-tile
              :class="{'selected' : selected_index == index}"
              :key="`${item.name}_${index}`"
              ripple
              avatar
              @click=""
            >
              <v-list-tile-avatar v-if="item.product">
                <img :src="item.product.thumbnail">
              </v-list-tile-avatar>
              <v-list-tile-content class="pr-3" @click="selected_index = (selected_index == index ? -1 : index) ">
                <v-list-tile-title>{{ (item.product && `${item.product.serial} (${item.product.display_name})`) || item.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.side_note }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action style="white-space: nowrap;">$ {{ item.price }} x {{ item.quantity }}</v-list-tile-action>
              <v-list-tile-action v-if="edit"><v-btn icon ripple @click="openDialog(index)"><v-icon color="grey lighten-1">edit</v-icon></v-btn></v-list-tile-action>
            </v-list-tile>
            <v-divider
              :key="index"
            ></v-divider>
          </template>
        </div>
        <div v-else>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title style="color: rgba(200,200,200,1);">未有貨品...</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
        </div>
      </v-list>
    </div>
    <div style="float: right" v-if="edit">
      <product-input ref="dialog" @edit="editItem" @new="addItem" :value="selected_index > -1 ? value[selected_index] : null" />
      <v-btn flat icon color="primary" @click="removeItem">
        <v-icon>remove</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ProductInput from './ProductInput'

export default {
  name: 'item-input',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selected_index: -1
    }
  },
  methods: {
    copySelected() {

    },
    addItem(item) {
      let item_copy = _.cloneDeep(item)
      let copy = _.cloneDeep(this.value)
      copy.push(item_copy)
      this.$emit('input', copy)
    },
    editItem(item) {
      let item_copy = _.cloneDeep(item)
      let copy = _.cloneDeep(this.value)
      copy.splice(this.selected_index, 1, item_copy)
      this.$emit('input', copy)
    },
    removeItem() {
      let copy = _.cloneDeep(this.value)
      copy.splice(this.selected_index, 1);
      this.selected_index = -1
      this.$emit('input', copy)
    },
    copyItem(i=null) {
      let item = i
      if (!item) item = this.value[this.selected_index]
      if (item) {
        let copy = _.cloneDeep(this.value)
        copy.push(item)
        this.$emit('input', copy)
      } else console.log("no item")
    },
    openDialog(index) {
      this.selected_index = index
      this.$refs['dialog'].open()
    },
  },
  components: { ProductInput }
}
</script>

<style scoped>
.item-input-container {
  position: relative;
  padding-top: 8px;
}
.items-container {
  margin-top: 3px;
  min-height: 42px;

  position: relative;
}
.selected {
  background: rgba(0,0,0,.04);
}
label {
  color: rgba(0,0,0,.54);
  transform: translateY(-18px) scale(.75);
}
</style>



// WEBPACK FOOTER //
// src/components/ItemInput.vue